import { CommonModule } from '@angular/common';
import { Component, computed, OnInit, signal, viewChild } from '@angular/core';

import { IColumn } from '@shared/interceptors/column.interface';
import { SessionContent } from '@app/shared/models/session.model';

import { Dialog } from 'primeng/dialog';

@Component({
  selector: 'app-kiosk-detail',
  imports: [CommonModule, Dialog],
  templateUrl: './kiosk-detail.component.html',
  styleUrl: './kiosk-detail.component.scss',
})
export class KioskDetailComponent {
  statusColumnTemplate = viewChild('statusColumnTemplate');

  displayDialog = signal<boolean>(false);
  selectedItem = signal<SessionContent | null>(null);

  getDeviceStatusList = computed(() => {
    return this.selectedItem()?.deviceStatusList ?? [];
  });

  onDialogHide() {
    this.selectedItem.set(null);
  }
}
